import React from 'react';
import styled from 'styled-components';

import Image from 'partials/Image';
import GridElement from 'partials/GridElement';
import IconSelector from 'partials/IconSelector';
import FavoriteButton from 'partials/FavoriteButton';
import SmartLink from 'partials/SmartLink';

export const LinkCard = props => {
    const { item } = props;

    return (
            <Grid>
                <GridElement
                    colStart={1}
                    colEnd={8}
                    rowStart={1}
                >
                    <SmartLink to={item.link}>
                        <StyledImage image={item.acf.image} background ratio="5:4" />
                    </SmartLink>
                </GridElement>
                <GridElement
                    colStart={1}
                    colEnd={5}
                    rowStart={2}
                    align="center"
                >
                    <SmartLink to={item.link}>
                        <Title>
                            <IconSelector icon={item.type === 'dining' ? 'bell' : item.acf.icon} />
                            <span>{item.acf.title}</span>
                        </Title>
                    </SmartLink>
                </GridElement>
                <GridElement
                    colStart={7}
                    colEnd={8}
                    rowStart={2}
                    justify="start"
                    align="center"
                >
                    <StyledFavoriteButton sort={item.type} item={item} />
                </GridElement>
            </Grid>
    )
}

export default LinkCard;


const Grid = styled.div`
    display: -ms-grid;
    display: grid;
    -ms-grid-columns: (1fr .359fr)[3] 1fr;
    grid-template-columns: repeat(3, 1fr .359fr) 1fr;
`

const StyledFavoriteButton = styled(FavoriteButton)`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto 0 auto auto;
`

const StyledImage = styled(Image)`
    margin-bottom: ${props => props.theme.spacing.contentM};

    &::after {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        content: '';
        background-color: transparent;
        transition: all .2s ease-in;
    }

    &:hover {
        &::after {
            background-color: rgba(0, 0, 0, .2);
        }
    }
`

const Title = styled.div`
    display: flex;

    svg {
        margin-right: ${props => props.theme.spacing.contentS}
    }

    span {
        ${props => props.theme.fonts.h4}
    }
`